import { Component, Input } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-image-ordering-loading',
  templateUrl: './image-ordering-loading.component.html',
  styleUrls: ['./image-ordering-loading.component.scss'],
})
export class ImageOrderingLoadingComponent {
  @Input() set platformType(pType: string) {
    this.isDesktop = pType === PlatformEnum.desktop;
    this.isTablet = pType === PlatformEnum.tablet;
    this.isMobile = pType === PlatformEnum.mobile;
  }

  isDesktop: boolean;
  isTablet: boolean;
  isMobile: boolean;

  constructor() {}
}
